import { render, staticRenderFns } from "./sos_map_page.vue?vue&type=template&id=1cb96c89&scoped=true&"
import script from "./sos_map_page.vue?vue&type=script&lang=js&"
export * from "./sos_map_page.vue?vue&type=script&lang=js&"
import style0 from "./sos_map_page.vue?vue&type=style&index=0&id=1cb96c89&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1cb96c89",
  null
  
)

export default component.exports